module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-opened-baa6ac63485fa2e280d57dfa0cc139a1.svg";